import { Box, Typography, useTheme, Tooltip } from "@mui/material";
import { ReactNode } from "react";

interface SegmentedSwitchProps {
  selected: "left" | "right";
  onChange: (value: "left" | "right") => void;
  leftIcon: ReactNode;
  leftLabel: string;
  rightIcon: ReactNode;
  rightLabel: string;
  tooltipText: string;
}

const SegmentedSwitch = ({
  selected,
  onChange,
  leftIcon,
  leftLabel,
  rightIcon,
  rightLabel,
  tooltipText,
}: SegmentedSwitchProps) => {
  const theme = useTheme();

  const buttonStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 0.5,
    paddingX: 4.5,
    paddingY: 0.8,
    cursor: "pointer",
    transition: "all 0.3s ease",
    flex: 1,
    whiteSpace: "nowrap",
    minWidth: 0,
  };

  const content = (
    <Box
      display="flex"
      alignItems="stretch"
      borderRadius="9999px"
      overflow="hidden"
      border={`1px solid ${theme.palette.primary.main}`}
      sx={{ backgroundColor: theme.palette.grey[100], width: "fit-content" }}
    >
      <Box
        sx={{
          ...buttonStyle,
          backgroundColor:
            selected === "left" ? theme.palette.primary.main : "transparent",
          color:
            selected === "left"
              ? theme.palette.primary.contrastText
              : theme.palette.text.primary,
        }}
        onClick={() => onChange("left")}
      >
        {leftIcon}
        <Typography fontWeight="bold" fontSize={14}>{leftLabel}</Typography>
      </Box>

      <Box
        sx={{
          ...buttonStyle,
          backgroundColor:
            selected === "right" ? theme.palette.primary.main : "transparent",
          color:
            selected === "right"
              ? theme.palette.primary.contrastText
              : theme.palette.text.primary,
        }}
        onClick={() => onChange("right")}
      >
        {rightIcon}
        <Typography fontWeight="bold" fontSize={14}>{rightLabel}</Typography>
      </Box>
    </Box>
  );



  return tooltipText ? (
    <Tooltip title={tooltipText} arrow>
      {content}
    </Tooltip>
  ) : (
    content
  );
};

export default SegmentedSwitch;
